var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_10387)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.748 21.4034H25.1861V2.56197H14.748V21.4034Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4107 11.9827C15.4107 8.16022 17.1924 4.7558 19.967 2.56197C17.9377 0.957285 15.3775 0 12.5947 0C6.00682 0 0.666504 5.36493 0.666504 11.9827C0.666504 18.6005 6.00682 23.9654 12.5947 23.9654C15.3775 23.9654 17.9377 23.0081 19.967 21.4035C17.1924 19.2093 15.4107 15.8052 15.4107 11.9827Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8948 19.4079V18.9429H38.7739L38.635 19.2628L38.4959 18.9429H38.3749V19.4079H38.4601V19.0571L38.5906 19.3596H38.6791L38.8097 19.0564V19.4079H38.8948ZM38.129 19.4079V19.0221H38.2841V18.9436H37.8898V19.0221H38.0445V19.4079H38.129ZM39.2673 11.9826C39.2673 18.6004 33.9266 23.9653 27.3391 23.9653C24.5562 23.9653 21.9958 23.008 19.9668 21.4033C22.7413 19.2095 24.5231 15.8051 24.5231 11.9826C24.5231 8.16045 22.7413 4.75603 19.9668 2.56186C21.9958 0.957178 24.5562 -0.000106812 27.3391 -0.000106812C33.9266 -0.000106812 39.2673 5.36482 39.2673 11.9826Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_10387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 24,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.83eb8e3531004965feb3b7fb57415cbf.svg";
export { ForwardRef as ReactComponent };